module.exports = __webpack_public_path__ + "static-v-shop/1785872208163/img/logo_master.c8bdcd8d.svg";